import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ overline, title, sub, dark = false, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`} data-testid={`section-head-${overline?.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
    <Reveal>
      <p className={`text-xs font-bold uppercase tracking-[0.25em] font-body ${dark ? "text-cyanx" : "text-electric"}`}>{overline}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className={`mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-[1.15] ${dark ? "text-white" : "text-navy"}`}>{title}</h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className={`mt-4 text-base sm:text-lg leading-relaxed ${dark ? "text-slate-400" : "text-slate-500"}`}>{sub}</p>
      </Reveal>
    )}
  </div>
);
